import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import axiosInstance from "../Auth/axiosInstance";
import SEO from "../components/SEO.jsx";

const SuccessStoriesPage = () => {
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const BASE_URL = process.env.REACT_APP_APP_URL;
  const API_URL = `${BASE_URL}/api/v1/topics/28/page/1/count/10`;


  useEffect(() => {
    AOS.init({ duration: 1200 });

    const fetchStories = async () => {
      try {
        const response = await axiosInstance.get(API_URL);
        setStories(response.data.topics || []);
      } catch (err) {
        setError("Error fetching data");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchStories();
  }, []);

  if (loading) {
    return (
      <>
        <section className="inner-banner-section success-stories about-top skeleton-container">
          <div className="container">
            <div className="row">
              <div className="col-xl-12 wow animate__animated animate__zoomIn" data-aos="zoom-in-right">
                <div className="banner-caption pr-0">
                  <div>
                    <div className="text-banner-badge text-center skeleton"></div>
                    <div className="main-heading text-center mb-0 skeleton"></div>
                  </div>
                  <p className="pera text-center skeleton"></p>
                  <div className="d-flex gap-3 justify-content-center">
                    <div className="btn-skeleton hero skeleton"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }

  if (error) {
    return (
      <section>
        <p className="error-message">{error}</p>
      </section>
    );
  }


  // Separate regular stories from bride stories
  const regularStories = stories.filter(story => 
    !story.title.toLowerCase().includes('bride')
  );
  
  const brideStories = stories.filter(story => 
    story.title.toLowerCase().includes('bride')
  );

  
  

  return (
    <>
      <SEO page="success-stories" />

      <section className="inner-banner-section about-top">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 wow animate__animated animate__zoomIn" data-aos="zoom-in-right">
              <div className="banner-caption pr-0">
                <div>
                  <h5 className="text-banner-badge text-center">
                    {stories[0]?.title || "Success Stories"}
                  </h5>
                  <h1 className="main-heading text-center mb-0">
                    {stories[0]?.fields.find(f => f.title === "Sub-Heading")?.value || "TRANSFORMATIONS + TESTIMONIALS"}
                  </h1>
                </div>
                <p className="pera text-center">
                  {stories[0]?.fields.find(f => f.title === "Description")?.value}
                </p>
                <div className="d-flex gap-3 justify-content-center">
                  <Link to="https://masterhabits.com/" target="_blank" className="btn theme_btn">
                    Take a Quiz Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Regular Success Stories Section */}
      <section className="success-stories-list sec_padding">
        <div className="container">
          <div className="row">
            <div className="col-12 mb-md-4 wow animate__animated animate__fadeInLeft" data-aos="fade-right">
              <h6 className="sub_heading">
                {stories[0]?.fields.find(f => f.title === "Success Stories Title")?.value || "Success Stories"}
              </h6>
              <h2 className="sec_heading-stylish">
                {stories[0]?.fields.find(f => f.title === "Success Story sub-title")?.value || "Together We Will Achieve Success!"}
              </h2>
            </div>
            <div className="col-md-12">
              {regularStories.map((story, index) => (
                <div className="row success-stories-item" key={story.id}>
                <div
  className={`col-lg-6 wow animate__animated ${
    index % 2 !== 0 ? 'animate__slideInRight order-1 order-lg-2' : 'animate__slideInLeft'
  }`}
  data-aos={index % 2 !== 0 ? 'fade-left' : 'fade-right'}
>

                    <div className="success-storie-img">
                      <img
                        src={`${BASE_URL}/uploads/topics/${story.fields.find(f => f.title === "Transformation Image")?.value}`}
                        alt={story.title}
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <div
  className={`col-lg-6 wow animate__animated ${
    index % 2 !== 0 ? 'animate__slideInLeft order-1' : 'animate__slideInRight'
  }`}
  data-aos={index % 2 !== 0 ? 'fade-right' : 'fade-left'}
>

                    <figure className="testimonial-qoute">
                      <blockquote className="pera">
                      <span className="quote-icon-top">“</span>
                        {story.fields.find(f => f.title === "Story Para One")?.value}<br /><br />
                        {story.fields.find(f => f.title === "Story Para Two")?.value}<br />
                        {story.fields.find(f => f.title === "Story Para Three")?.value && (
                    <>
                      <br /><br />
                      {story.fields.find(f => f.title === "Story Para Three")?.value}
                    </>
                  )}
                  {story.fields.find(f => f.title === "Story Para Four")?.value && (
                    <>
                      <br /><br />
                      {story.fields.find(f => f.title === "Story Para Four")?.value}
                    </>
                  )}
                        <span className="quote-icon-bottom">”</span>
                      </blockquote>
                      <figcaption className="source text-end">
                        — {story.fields.find(f => f.title === "Name")?.value}, 
                        {story.fields.find(f => f.title === "Age")?.value} years old
                      </figcaption>
                    </figure>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Bride Success Stories Section */}
      {brideStories.length > 0 && (
        <section id="bride-success-stories" className="success-stories-list bride sec_padding">
          <div className="container">
            <div className="row">
              <div className="col-12 mb-md-4 wow animate__animated animate__fadeInLeft" data-aos="fade-right">
                <h6 className="sub_heading">
                  {brideStories[0]?.fields.find(f => f.title === "Success Stories Title")?.value || "Bride Success Stories"}
                </h6>
                <h2 className="sec_heading-stylish">
                  {brideStories[0]?.fields.find(f => f.title === "Success Story sub-title")?.value || "A Journey to the Perfect Day!"}
                </h2>
              </div>
              <div className="col-md-12">
                {brideStories.map((story, index) => (
                  <div className="row success-stories-item" key={story.id}>
                  <div
  className={`col-lg-6 wow animate__animated ${
    index % 2 !== 0 ? 'animate__slideInRight order-1 order-lg-2' : 'animate__slideInLeft'
  }`}
  data-aos={index % 2 !== 0 ? 'fade-left' : 'fade-right'}
>

                      <div className="success-storie-img">
                        <img
                          src={`${BASE_URL}/uploads/topics/${story.fields.find(f => f.title === "Transformation Image")?.value}`}
                          alt={story.title}
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <div
  className={`col-lg-6 wow animate__animated ${
    index % 2 !== 0 ? 'animate__slideInLeft order-1' : 'animate__slideInRight'
  }`}
  data-aos={index % 2 !== 0 ? 'fade-right' : 'fade-left'}
>

                      <figure className="testimonial-qoute">
                        <blockquote className="pera">
                        <span className="quote-icon-top">“</span>
                          {story.fields.find(f => f.title === "Story Para One")?.value}<br /><br />
                          {story.fields.find(f => f.title === "Story Para Two")?.value}<br />
                          {story.fields.find(f => f.title === "Story Para Three")?.value && (
                      <>
                        <br /><br />
                        {story.fields.find(f => f.title === "Story Para Three")?.value}
                      </>
                    )}
                    {story.fields.find(f => f.title === "Story Para Four")?.value && (
                      <>
                        <br /><br />
                        {story.fields.find(f => f.title === "Story Para Four")?.value}
                      </>
                    )}
                          <span className="quote-icon-bottom">”</span>
                        </blockquote>
                        <figcaption className="source text-end">
                          — {story.fields.find(f => f.title === "Name")?.value}, 
                          {story.fields.find(f => f.title === "Age")?.value} years old
                        </figcaption>
                      </figure>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default SuccessStoriesPage;